import { getUrl } from './connection'
import { CLIENT_STORAGE_NAME, getLocalStorage } from './storageUtils'
import { authHeader, getClient } from './session'
import { translate } from './i18n'

import { loading } from './stores/loading'
import { alert } from './stores/alert'

const getRate = async () => {
    const clientId = getClient()
    if (!clientId) return
    const type = 'clientdata'
    const [url, method] = await getUrl(type, { id: clientId });
    loading.newLoading()
    try {
        const response = await fetch(url, {
            method,
            headers: Object.assign({ 'Content-Type': 'application/json; charset=utf-8' }, authHeader()),
        })
        if (response.status === 200) {
            const result = await response.json()
            result.data.rate = result.data.factoryPrice;  // El valor es equivalente, y se usa en algunos sitios
            return result;
        }
        return { status: response.status, message: (await response.json())['response'] }
    } catch (err) {
        alert.newAlert({ message: translate('alerts.errors.notLoadRate'), type: 'error' })
        throw err
    } finally {
        loading.removeLoading()
    }
}

const saveRate = async (rate) => {
    const clientId = getLocalStorage(CLIENT_STORAGE_NAME)
    if (!clientId)
        throw { error: 'Not current client' }
    const type = 'saverate'
    const [url, method] = await getUrl(type, { id: clientId });
    const response = await fetch(url, {
        method,
        headers: Object.assign({ 'Content-Type': 'application/json; charset=utf-8' }, authHeader()),
        body: JSON.stringify(rate)
    })
    if (response.status === 200) {
        return await response.json()
    }
    return { status: response.status, message: (await response.json())['response'] }
}


export { getRate, saveRate }

